export default {
  title: '来源渠道管理',
  menu: '来源渠道管理',
  tab: {
    channelManagement: '渠道管理',
    sourceCodeManagement: 'SourceCode管理',
    channelAdd: '添加渠道',
    sourceCodeEdit: '编辑SourceCode',
    sourceCodeAdd: '添加SourceCode'
  },
  label: {
    affiliatedCompany: '所属公司',
    chineseName: '中文名',
    englishName: '英文名',
    status: '状态',
    channelSelect: '渠道选择',
    statusSelect: '状态选择',
    all: '全部',
    enable: '激活',
    disable: '禁用',
    channelAdd: '添加渠道',
    channelEdit: '编辑渠道',
    companyName: '公司名称',
    classified: '已归类',
    unclassified: '未归类',
    source: 'Source',
    code: 'Code',
    channel: '渠道',
    selectable: '可选',
    sourceCodeEdit: '编辑SourceCode',
    sourceCodeAdd: '添加SourceCode',
    parentChannel: '使用父公司的渠道',
    weChatChannel: '微信'
  },
  placeholder: {
    search: '搜索',
    chineseName: '请输入中文名',
    englishName: '请输入英文名',
    source: '请输入Source',
    code: '请输入Code',
    channel: '请选择渠道'
  },
  message: {
    optionSuccess: '操作成功',
    required: '这是必填项。'
  },
  tip: {
    selectableTip: '编辑/上传候选人可选择。'
  }
}
